import {
  FormGroup,
  FormControl,
  ValidatorFn,
  AbstractControl
}  from '@angular/forms';

/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.equalsTo)
 * ```
 */
export class WoopaValidators {
  /**
   * Validator that compares the value of the given FormControls
   */
  static equalsTo(...fieldPaths: string[]): ValidatorFn {
    return function(control: FormControl): {[key: string]: any} {
      // Check if field paths is empty, throw error
      if (fieldPaths.length < 1) {
        throw new Error('You must compare to at least 1 other field');
      }
      // Check if control has parent
      if (!control.parent) {
        return null;
      }
      // For each field check if has the same value
      for (let fieldName of fieldPaths) {
        let field = (<FormGroup>control.parent).get(fieldName);
        if (!field) {
          throw new Error(
              `Field: ${fieldName} undefined, are you sure that ${fieldName} exists in the group`);
        }
        // Check field and control values
        if (field.value !== control.value) {
          return {'equalsTo': {'unequalField': fieldName}};
        }
      }
      return null;
    };
  }

  /**
   * Validator that requires controls to maximun value.
   */
  static maxValue(max: Number): ValidatorFn {
    return function (control: AbstractControl): {[key: string]: any} {
      const input = control.value,
            error = input > max;
    return error ? { 'maxValue': true } : null;
    };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/forms/woopa-validators.ts